'use strict';

export default class Slider {
  constructor() {
    this.name = 'slider';
    // $('.paragraph--type--image .field--name-field-multiple-media').
  }

  initSlider(el, slideToShow, options) {
    let slideItems = el.children().length;

    /** Slick  arrows and navigation */
    var arrowWrapper = $(`<div class = "arrow-position"></div>`)
    var prevButton = $(`<div id ="prev-arrow"></div>`);
    var nextButton = $(`<div id = "next-arrow"></div>`);

    prevButton.on('click', () => {
      el.slick("slickPrev");
    });

    nextButton.on('click', () => {
      el.slick("slickNext");
    });

    arrowWrapper.append(prevButton).append(nextButton);

    if (options.showSummary) {
      
      let summaryBlock = $(`<span class='flex items-center'><span class='current-slide'>1</span> / ${slideItems}</span>`);
      prevButton.after(summaryBlock);

      el.on("afterChange", (event, slick) => {
        summaryBlock.find('.current-slide').html((slick.currentSlide + 1));
      })
    }


    el.after(arrowWrapper);
    $(el).slick({
      dots: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: slideToShow,
      speed: 300,
      slidesToScroll: 1,
      arrows: false,
      variableWidth: false,
      afterChange: function (slick, currentSlide) {
        // Your function to execute on slide change
        console.log("Slide changed to: " + currentSlide);
        // You can add your custom logic or function calls here
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1
          }
        },
      ]

    })
  }
}
